import DomainObjectForm from 'app/shared-components/DomainObjectForm'
import {
    ServiceCenterFormType,
} from 'app/Apps/ContainerManagement/ServiceCenters/serviceCenters.types'
import useContainerManagementRoutes from 'app/SkyNetRoutes/hooks/useContainerManagementRoutes'
import useEnumValues from 'app/hooks/useEnumValues'
import {
    generateSkyNetLink,
} from 'app/SkyNetRoutes'
import {
    ChangeRequestApprovalType,
} from 'app/Apps/OrderManagement/Orders/orders.types'

import getFields from './generalInformation.fields'

const GeneralInformation = ({
    requestApproval,
    serviceCenter,
}: {
    requestApproval: ChangeRequestApprovalType,
    serviceCenter: ServiceCenterFormType,
}) => {
    const {
        ServiceCenters: ServiceCentersRoutes,
    } = useContainerManagementRoutes()
    const getAllowedValues = useEnumValues()

    const fields = getFields({
        getAllowedValues,
        serviceCenter,
        serviceCenterNumberLink: serviceCenter?.id ? generateSkyNetLink({
            domainPath: ServiceCentersRoutes.Overview.path,
            params: {
                key: serviceCenter?.id,
            },
        }) : null,
    })

    return (
        <DomainObjectForm
            value={requestApproval}
            disabled
            fields={fields}
            name="GeneralInformation"
        />
    )
}

export default GeneralInformation
